import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry
*/
import React, { useState, useCallback } from 'react';
import Block from 'wfui-digital-core/es/Block';
import Markup from 'wfui-digital-core/es/Markup';
import Button from 'wfui-digital-core/es/Button';
import Translatable from 'wfui-digital-core/es/Translatable';
import ArrowIcon from 'wfui-digital-core/es/ArrowIcon';
import TriangleIcon from 'wfui-digital-core/es/TriangleIcon';
import useBrand from 'wfui-digital-core/es/useBrand';
import { getClasses } from 'wfui-digital-core/es/lib';
import useSettings from '../../../../../hooks/use-settings';
import CustomerAvatarIcon from '../../../../../icons/customer-avatar-icon-bim/CustomerAvatarIcon';
import ProfileModal from '../../profile-modal/ProfileModal';
import styles from './MastheadAvatarButton.less';

var MastheadAvatarButton = function MastheadAvatarButton(_ref) {
  var attributes = _ref.attributes,
      welcomeText = _ref.welcomeText;
  var brand = useBrand();

  var _useSettings = useSettings(),
      useTPBBimUpdates = _useSettings.useTPBBimUpdates;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      target = _useState4[0],
      setTarget = _useState4[1];

  var targetRef = useCallback(function (node) {
    if (node !== null) {
      setTarget(node);
    }
  }, []);

  var openModal = function openModal() {
    return setIsModalOpen(true);
  };

  var closeModal = function closeModal() {
    return setIsModalOpen(false);
  };

  var classes = ['avatarButton', isModalOpen && 'open', useTPBBimUpdates && 'useTPBBimUpdates'];
  var classNames = getClasses({
    styles: styles,
    classes: classes,
    brand: brand
  });
  return /*#__PURE__*/React.createElement(Block, {
    el: "li",
    pl: "s",
    layout: true,
    horizontal: true,
    center: true,
    className: classNames
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: openModal,
    buttonRef: targetRef,
    "aria-expanded": isModalOpen
  }, /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    center: true
  }, /*#__PURE__*/React.createElement(Block, {
    pl: "xxxs",
    layout: true,
    vertical: true,
    center: true
  }, /*#__PURE__*/React.createElement(CustomerAvatarIcon, {
    height: "40px",
    width: "40px",
    viewBox: "0 0 40 40"
  })), /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    center: true
  }, /*#__PURE__*/React.createElement(Block, {
    className: styles.welcomeText,
    layout: true,
    horizontal: true,
    center: true
  }, /*#__PURE__*/React.createElement(Markup, {
    className: styles.welcomeLine,
    content: welcomeText
  }), /*#__PURE__*/React.createElement(Translatable, {
    id: "global.profile.menu",
    className: "visuallyHidden"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.arrowIcon
  }, /*#__PURE__*/React.createElement(ArrowIcon, {
    className: styles.arrow,
    width: "6px",
    height: "12px"
  }))), isModalOpen && /*#__PURE__*/React.createElement("div", {
    className: styles.triangle
  }, /*#__PURE__*/React.createElement(TriangleIcon, null)))), /*#__PURE__*/React.createElement(ProfileModal, {
    isOpen: isModalOpen,
    closeModal: closeModal,
    onFrameworkClose: closeModal,
    target: target,
    profileAttributes: attributes,
    brand: brand
  }));
};

export default MastheadAvatarButton;